import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core';
import { AddAlert } from '@material-ui/icons';
import GridItem from '../../components/Grid/GridItem';
import CardBody from '../../components/Card/CardBody';
import GridContainer from '../../components/Grid/GridContainer';
import Card from '../../components/Card/Card';
import Snackbar from '../../components/Snackbar/Snackbar';
import Button from '../../components/CustomButtons/Button';
import Loading from '../../components/Loading';
import { updateActivity } from '../../dataService/updateActivity';
import DiscountFormBlock from './FormParts/DiscountFormBlock';
import { getActivityInfo } from '../../dataService/getActivityInfo';
import { yupSchemaObject, initialValues } from './formSchema';

const EditActivity = ({
  match: {
    params: { activityCode },
  },
}) => {
  const classes = useStyles();
  const [formValues, setFormValues] = useState(initialValues);
  const validationSchema = Yup.object(yupSchemaObject);
  const [isLoaded, setIsLoaded] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: '',
    color: 'success',
  });

  const snackBarClose = () => {
    setSnackbarConfig({ ...snackbarConfig, open: false });
  };

  const setSchemaAndInitialValueForEditForm = async activityCode => {
    const { data: formValues } = await getActivityInfo(activityCode, true);

    setFormValues(formValues);
    setIsLoaded(true);
  };

  useEffect(() => {
    setSchemaAndInitialValueForEditForm(activityCode);
  }, []);

  const onSubmit = async values => {
    setSubmitDisable(true);

    const { status, message } = await updateActivity(values);

    if (status === 'success') {
      setSubmitDisable(false);
      setSnackbarConfig({
        open: true,
        message,
        icon: AddAlert,
        color: 'success',
      });
      setSchemaAndInitialValueForEditForm(activityCode);
    } else {
      setSubmitDisable(false);
      setSnackbarConfig({
        open: true,
        message,
        icon: AddAlert,
        color: 'danger',
      });
    }
  };

  if (!isLoaded) {
    return (
      <>
        <Card style={{ backgroundColor: '#800054' }}>
          <CardBody>
            <h3 style={{ color: '#ffffff' }}>
              <b>Edit Activity: {activityCode}</b>
            </h3>
          </CardBody>
        </Card>
        <Loading
          className={classes.pageTopSpacing}
          boxHeight="calc(100vh - 122px)"
        />
      </>
    );
  }

  return (
    <>
      <Card style={{ backgroundColor: '#800054' }}>
        <CardBody>
          <h3 style={{ color: '#ffffff' }}>
            <b>Edit Activity: {activityCode}</b>
          </h3>
        </CardBody>
      </Card>
      <Formik
        enableReinitialize
        initialValues={formValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {formik => (
          <form
            className={classes.pageTopSpacing}
            onSubmit={formik.handleSubmit}
          >
            <GridContainer>
              <GridItem xs={12}>
                <DiscountFormBlock formik={formik} isEdit />

            
                <GridContainer>
                  <GridItem>
                    <Button
                      disabled={
                        submitDisable ||
                        (formik.isValid && !formik.dirty) ||
                        !formik.isValid
                      }
                      color="success"
                      type="submit"
                    >
                      Update Activity
                    </Button>
                  </GridItem>
                </GridContainer>
            
              </GridItem>
            </GridContainer>
          </form>
        )}
      </Formik>
      <Snackbar
        {...snackbarConfig}
        icon={AddAlert}
        close
        closeNotification={snackBarClose}
        place="bl"
      />
    </>
  );
};

const useStyles = makeStyles({
  pageTopSpacing: {
    marginTop: '30px',
  },
  blockSpacing: {
    marginTop: '60px',
  },
});

export default EditActivity;
